import ImportDetailPage from "./import-detail-page" ;

export default ImportDetailPage 